<ng-container *ngIf="showContent">


  <section class="list-section" [ngClass]="{ 'stripMarginAddedDetailPage': stripMargin,
  'subscribe-strip-margin':  shouldShowTrialBanner }">
    <div class="container-fluid">
      <!--Navbar Start From Here-->
      <nav aria-label="breadcrumb" class="breadcrumb-section d-flex justify-content-between mb-2">
        <ol class="breadcrumb align-items-center">

          <li class="breadcrumb-item d-flex align-items-center">
            <a class="btn quinary-btn" routerLink="">Home </a>
            <i class=" breadcrumb-arrow-right sprite-img-list "></i>
          </li>
          <li class="breadcrumb-item d-flex align-items-center">
            <a (click)="navigate('/all-tenders/active'); $event.preventDefault()"
              [href]="baseUrl + '/all-tenders/active'" class="btn quinary-btn">
              Indian Tenders
            </a>

            <i class=" breadcrumb-arrow-right sprite-img-list "></i>
          </li>
          <li class="breadcrumb-item d-flex align-items-center">
            <a (click)="navigate('/' + (tender?.state?.link || '') + '-tenders/active'); $event.preventDefault()"
              [href]="baseUrl + '/' + (tender?.state?.link || '') + '-tenders/active'" class="btn quinary-btn">
              {{tender?.state?.name}} Tenders
            </a>
            <i class=" breadcrumb-arrow-right sprite-img-list "></i>
          </li>
          <li class="breadcrumb-item d-flex align-items-center">

            <a (click)="navigate('/authority/' + (tender?.authority?.link || '') + '-tenders/active'); $event.preventDefault()"
              [href]="baseUrl + '/authority/' + (tender?.authority?.link || '') + '-tenders/active'"
              class="btn quinary-btn">
              {{ tender?.authority === null ? tender?.ministry?.name : tender?.authority?.name }}
            </a>
            <i class=" breadcrumb-arrow-right sprite-img-list "></i>
          </li>
          <li class="breadcrumb-item active">Overview</li>
        </ol>
        <button class="btn-grey-round" *ngIf="tenderClosingDateDiff < 0">
          <span>Expired</span>
        </button>
      </nav>
      <!--Navbar End Here-->

      <!--Main Tender Details Section Start From Here-->
      <div class="row">
        <div class="col-sm-10">
          <!----New card start --->
          <div class="card card-3 detail-card mb-30">
            <div class="card-body card-body d-flex justify-content-between row">
              <div class="border-0 d-flex flex-column pb-0 col-sm-9 col-12 p-0">
                <h1 class="mb-0" class="hover-underline">{{ tender?.authority === null ? tender?.ministry?.name :
                  tender?.authority?.name }}
                  Tender
                </h1>
                <div class="d-flex flex-wrap">
                  <div class="tender-status-badge d-inline-block me-2 blue-badge">
                    <span>{{tender?.tenderCategory}}</span>
                  </div>

                  <div *ngIf="tender?.categoryList?.length > 0" class="cursor-pointer tag-tooltip-hover">
                    <div class="tender-status-badge d-inline-block me-2" [ngClass]="['blue-badge']">
                      <span>{{ tender?.categoryList[0] }}</span>
                      <div *ngIf="tender?.categoryList.length > 1" class=" view-more-blue-text d-inline-block ">
                        <span class="tooltip-trigger">
                          + {{ tender?.categoryList?.length - 1 }}
                        </span>
                        <div class="tooltip-content tag-dropdown">
                          <div class="tag-item" *ngFor="let item of tender?.categoryList?.slice(1)">
                            <span>{{ item }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="location d-flex align-items-center">
                    <i class="sprite-img-list location-icon"></i>
                    <span><a href="/{{tender?.city?.link}}-tenders/active">{{tender?.city?.name}}</a><span
                        *ngIf="tender?.state?.name">, </span>
                      <a href="/{{tender?.state?.link}}-tenders/active">{{tender?.state?.name}}</a></span>
                  </div>
                </div>
                <p>
                  {{tender?.tenderTitle}}
                </p>
              </div>
              <div
                class="col-sm-3 pe-0  d-none d-lg-flex  flex-column justify-content-end justify-content-lg-between align-items-end col-12">
                <div class="d-flex align-items-center">

                  <div *ngIf="tender?.documents && tender.documents?.length > 0">
                    <div *ngIf="isLoggedIn">
                      <a class="btn blue-round-btn me-3 mt-10" (click)="downloadDoc(tender?.documents[0])">
                        <i class="download-icon sprite-img-list me-2"></i>
                        Download
                      </a>
                    </div>
                    <div *ngIf="!isLoggedIn">
                      <a class="btn blue-round-btn me-3 mt-10" (click)="openModalWithComponent()">
                        <i class="download-icon sprite-img-list me-2"></i>
                        Download
                      </a>
                    </div>
                  </div>

                  <div class="sharing-section align-self-end d-none d-lg-block">
                    <div class="sharing-option">
                      <span>Share this Tender</span>
                      <ul class="list-inline d-flex">
                        <li class="list-inline-item">
                          <a class="cursor ps-0"
                            (click)="shareTenderDetails('mailto:?subject='+tender?.summary+'&body='+currentPageUrl, 'Email')">
                            <i class="sprite-img-list red-mail mail-icon"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a class="cursor"
                            (click)="shareTenderDetails('https://web.whatsapp.com/send?text='+currentPageUrl, 'WhatsApp')">
                            <i class="sprite-img-list whatsapp-icon-green whatsapp-icon"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a class="clipboard-icon" [ngClass]="{'show': isTooltipActive}"
                            (click)="copyTextToClipboard()"
                            (mouseover)="tooltip = 'Copy to Clipboard'; isTooltipActive = false;">
                            <i class="sprite-img-list link-icon-blue copy-icon"></i>

                            <span class="hovercard">
                              <span class="tooltiptext">{{tooltip}}</span>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-sm-12 p-0 d-flex align-items-center justify-content-between">
                <ul class="list-group list-group-horizontal p-0 m-0">
                  <li class="list-group-item border-0 p-0 d-flex mb-2 flex-column">
                    <span class="d-block list-heading">Opening Date</span>
                    <span class="d-block list-heading">{{formattedDate}}</span>
                  </li>
                  <li class="list-group-item border-0 p-0 d-flex mb-2 flex-column">
                    <span class="d-block list-heading">Closing Date</span>
                    <span class="d-block list-heading">{{bidSubmissionEndDateformattedDate}}</span>
                  </li>
                  <li class="list-group-item border-0 p-0 d-flex flex-column">
                    <span class="d-block list-heading">Tender Amount</span>
                    <span class="badge bg-danger p-0 text-start text-red" [ngClass]="{
                    'text-red': tender?.amount !== null && tender?.amount !== 0
                  }">
                      {{tender?.amount === null || tender?.amount === 0 ? 'Refer Document' : tender?.amount |
                      tenderAmount}}
                    </span>
                  </li>
                </ul>
                <!-- 2 types of button -->
                <button *ngIf="isLoggedIn" (click)="ThankyouMessagePopup()" type="button"
                  class="btn btn-danger view-details-btn interested-btn-width d-none d-lg-block">
                  Yes I Am Interested
                </button>

                <button *ngIf="!isLoggedIn" (click)="leadFormPopup(tender)" type="button"
                  class="btn btn-danger view-details-btn view-details-btn interested-btn-width d-none d-lg-block">
                  Yes I Am Interested
                </button>
              </div>
              <div class="d-block d-lg-none p-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center" *ngIf="tender?.documents && tender.documents.length > 0">


                    <div class="me-3" *ngIf="isLoggedIn">
                      <a class="btn blue-round-btn me-3" (click)="downloadDoc(tender?.documents[0])">
                        <i class="download-icon sprite-img-list me-2"></i>
                        Download
                      </a>
                    </div>

                    <div class="me-3" *ngIf="!isLoggedIn">
                      <a class="btn blue-round-btn me-3" (click)="openModalWithComponent()">
                        <i class="download-icon sprite-img-list me-2"></i>
                        Download
                      </a>
                    </div>
                  </div>

                  <div class="sharing-section sharing-detail align-self-end d-block d-lg-none">
                    <div class="sharing-option">
                      <span>Share this Tender</span>
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a class="cursor ps-0"
                            (click)="shareTenderDetails('mailto:?subject='+tender?.summary+'&body='+currentPageUrl, 'Email')">
                            <i class="sprite-img-list red-mail mail-icon"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a class="cursor" (click)="shareTenderDetailsWhatsapp()">
                            <i class="sprite-img-list whatsapp-icon-green whatsapp-icon"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a class="clipboard-icon" [ngClass]="{'show': isTooltipActive}"
                            (click)="copyTextToClipboard()"
                            (mouseover)="tooltip = 'Copy to Clipboard'; isTooltipActive = false;">
                            <i class="sprite-img-list link-icon-blue copy-icon"></i>

                            <span class="hovercard">
                              <span class="tooltiptext">{{tooltip}}</span>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
                <button *ngIf="isLoggedIn" (click)="ThankyouMessagePopup()" type="button"
                  class="btn btn-danger view-details-btn  d-block d-lg-none w-100">
                  Yes I Am Interested
                </button>
                <button *ngIf="!isLoggedIn" (click)="leadFormPopup(tender)" type="button"
                  class="btn btn-danger view-details-btn  d-block d-lg-none w-100">
                  Yes I Am Interested
                </button>

              </div>
            </div>
          </div>
          <!----New card end --->
          <div class="horizontal-tab" id="navTabshorizontal">
            <!-- Tab List -->
            <ul role="tablist" class="nav nav-tabs" aria-label="Tabs">
              <li class="nav-item d-none d-lg-block" role="presentation">
                <a (click)="navigateToSection(overview, $event)" [ngClass]="{ active: highlightSection == 'overview' }"
                  role="tab" class="nav-link cursor" [attr.aria-controls]="'overview-panel'"
                  [attr.aria-selected]="highlightSection == 'overview' ? 'true' : 'false'">
                  <span>Overview</span>
                </a>
              </li>
              <li class="nav-item d-block d-lg-none mobile-tab" role="presentation">
                <a (click)="navigateToSection(overviewMobile, $event)"
                  [ngClass]="{ active: highlightSectionMobile == 'overviewMobile' }" role="tab" class="nav-link cursor"
                  [attr.aria-controls]="'overviewMobile-panel'"
                  [attr.aria-selected]="highlightSectionMobile == 'overviewMobile' ? 'true' : 'false'">
                  <span>Overview</span>
                </a>
              </li>
              <li class="nav-item d-none d-lg-block" role="presentation">
                <a (click)="navigateToSection(ImportantDates, $event)"
                  [ngClass]="{ active: highlightSection == 'ImportantDates' }" role="tab" class="nav-link cursor"
                  [attr.aria-controls]="'ImportantDates-panel'"
                  [attr.aria-selected]="highlightSection == 'ImportantDates' ? 'true' : 'false'">
                  <span>Important Dates</span>
                </a>
              </li>
              <li class="nav-item d-block d-lg-none mobile-tab" role="presentation">
                <a (click)="navigateToSection(ImportantDatesMobile, $event)"
                  [ngClass]="{ active: highlightSection == 'ImportantDatesMobile' }" role="tab" class="nav-link cursor"
                  [attr.aria-controls]="'ImportantDatesMobile-panel'"
                  [attr.aria-selected]="highlightSection == 'ImportantDatesMobile' ? 'true' : 'false'">
                  <span>Important Dates</span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a (click)="navigateToSection(CostSpecification, $event)"
                  [ngClass]="{ active: highlightSection == 'CostSpecification' }" role="tab" class="nav-link cursor"
                  [attr.aria-controls]="'CostSpecification-panel'"
                  [attr.aria-selected]="highlightSection == 'CostSpecification' ? 'true' : 'false'">
                  <span>Cost Specification</span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a (click)="navigateToSection(TenderDescriptions, $event)"
                  [ngClass]="{ active: highlightSection == 'TenderDescriptions' }" role="tab" class="nav-link cursor"
                  [attr.aria-controls]="'TenderDescriptions-panel'"
                  [attr.aria-selected]="highlightSection == 'TenderDescriptions' ? 'true' : 'false'">
                  <span>Tender Description</span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a (click)="navigateToSection(TenderContactDetails, $event)"
                  [ngClass]="{ active: highlightSection == 'TenderContactDetails' }" role="tab" class="nav-link cursor"
                  [attr.aria-controls]="'TenderContactDetails-panel'"
                  [attr.aria-selected]="highlightSection == 'TenderContactDetails' ? 'true' : 'false'">
                  <span>Tender Contact Details</span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a (click)="navigateToSection(document, $event)" [ngClass]="{ active: highlightSection == 'document' }"
                  role="tab" class="nav-link cursor" [attr.aria-controls]="'document-panel'"
                  [attr.aria-selected]="highlightSection == 'document' ? 'true' : 'false'">
                  <span>Tender Documents</span>
                </a>
              </li>
            </ul>


          </div>
          <div class="horizontal-tab mt-40">
            <!--Tender Overview Start From Here-->
            <div class="card card-4 border-0 desription-card d-none d-lg-block" id="overview_section" #overview>
              <div class="card-header border-bottom-0 mb-0">
                <h3 class="mb-0">Tender Overview</h3>
              </div>

              <!-- <div class="blurred-wrapper">
                <div [class.blurred-restricted]="!planAccess.hasAccess('pdpTenderOverview')">
                  <h3>Tender Overview</h3>
                  <p>..
                   my name is prashant singh</p>
                </div>

                <div *ngIf="!planAccess.hasAccess('pdpTenderOverview')" class="blur-overlay">
                  <button class="btn btn-primary" (click)="openUpgradeModal()">Upgrade Now</button>
                  <a (click)="redirectToSignup()" class="ml-2">Sign up</a>
                </div>
              </div> -->


              <div [appRestrictByFeature]="'pdpTenderOverview'" [appRestrictByStateSlug]="stateSlug"
                class="card-body p-0">
                <div class="table-responsive">
                  <table class="tender-info-table table-stripped">
                    <tr>
                      <td><span class="cell-label"> Tender Title </span></td>
                      <td colspan="3">
                        <span class="cell-detail">{{tender?.tenderTitle}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td><span class="cell-label">Tender ID</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderId}}</span>
                      </td>
                      <td><span class="cell-label">Tender Reference Number</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderRefId}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="cell-label">Tender Type</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderType}}</span>
                      </td>
                      <td>
                        <span class="cell-label"></span>
                      </td>
                      <td>
                        <span class="cell-detail"></span>
                      </td>
                    </tr>

                    <tr>
                      <td><span class="cell-label">Tender Opening Date</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.bidSubmissionStartDate}}</span>
                      </td>
                      <td><span class="cell-label">Tender Closing Date</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.bidSubmissionEndDate}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td><span class="cell-label">Tender Value</span></td>
                      <td><span class="cell-detail">
                          {{tender?.amount === null || tender?.amount === 0 ? 'Refer Document' : tender?.amount|
                          tenderAmount}} </span></td>
                      <td><span class="cell-label">Tender Location</span></td>
                      <td><span class="cell-detail">{{tender?.location}} <span *ngIf="tender?.city?.name">,</span>
                          {{tender?.city?.name}} <span *ngIf="tender?.state?.name">,</span>
                          {{tender?.state?.name}}</span></td>

                    </tr>

                    <tr>
                      <td><span class="cell-label">Tender Category</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderCategory}}</span>
                      </td>
                      <td>
                        <span class="cell-label">Product Category</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.category}}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

            </div>

            <!---mobile view start --->
            <div class="card-12 d-block d-lg-none" id="overview_sectionMobile" #overviewMobile>
              <div class="card-header">
                Tender Overview
              </div>
              <div class="card-body" [appRestrictByFeature]="'pdpTenderOverview'" [appRestrictByStateSlug]="stateSlug">
                <ul>
                  <li>
                    <span class="heading ">Tender Title</span>
                    <span class="content w-100 content-width">{{tender?.tenderTitle}}</span>
                  </li>
                  <li>
                    <span class="heading ">Tender ID</span>
                    <span class="content ">{{tender?.tenderId}}</span>
                  </li>
                  <li>
                    <span class="heading ">Tender Reference Number</span>
                    <span class="content ">{{tender?.tenderRefId}}</span>
                  </li>

                  <li>
                    <span class="heading ">Tender Type</span>
                    <span class="content ">{{tender?.tenderType}}</span>
                  </li>

                  <li>

                    <span class="heading">Tender Opening Date</span>
                    <span class="content">{{tender?.bidSubmissionStartDate}}</span>

                  </li>
                  <li>

                    <span class="heading">Tender Closing Date</span>
                    <span class="content">{{tender?.bidSubmissionEndDate}}</span>

                  </li>
                  <li>

                    <span class="heading ">Tender Value</span>
                    <span class="content "> {{tender?.amount === null || tender?.amount === 0 ? 'Refer Document' :
                      tender?.amount|
                      tenderAmount}}</span>

                  </li>
                  <li>
                    <span class="heading ">Tender Location</span>
                    <span class="content ">{{tender?.location}}<a *ngIf="tender?.location">,</a>{{tender?.city?.name}},
                      {{tender?.state?.name}}</span>
                  </li>
                  <li>
                    <span class="heading">Tender Category</span>
                    <span class="content">{{tender?.tenderCategory}}</span>
                  </li>
                  <li>
                    <span class="heading">Product Category</span>
                    <span class="content">{{tender?.category}}</span>
                  </li>
                </ul>
              </div>

            </div>
            <!---mobile view end--->
            <!--Tender Overview End From Here-->

            <!--Important Dates Start From Here-->
            <div class="card card-4 border-0 desription-card mt-40  d-none d-lg-block" id="ImportantDates_section"
              #ImportantDates>
              <div class="card-header border-bottom-0 mb-0">
                <h3 class="mb-0">Important Dates</h3>
              </div>
              <div class="card-body p-0" [appRestrictByFeature]="'pdpTenderOverview'"
                [appRestrictByStateSlug]="stateSlug">
                <div class="table-responsive">
                  <table class="tender-info-table table-stripped">
                    <tr>
                      <td><span class="cell-label">ePublished Date </span></td>
                      <td>
                        <span class="cell-detail"> {{tender?.publishDate}} </span>
                      </td>

                      <td><span class="cell-label">Bid Opening Date</span></td>
                      <td>
                        <span class="cell-detail">{{tender?.bidOpeningDate}}</span>
                      </td>

                    </tr>

                    <tr>
                      <td>
                        <span class="cell-label">Document Download Start Date</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.docDownloadStartDate}}</span>
                      </td>
                      <td>
                        <span class="cell-label">Document Download End Date</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.docDownloadEndDate}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="cell-label">Bid Submission Start Date</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.bidSubmissionStartDate}}</span>
                      </td>

                      <td>
                        <span class="cell-label">Bid Submission End Date</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.bidSubmissionEndDate}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="cell-label">Clarification start Date</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.clarificationStartDate}}</span>
                      </td>

                      <td>
                        <span class="cell-label">Clarification End Date</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.clarificationEndDate}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="cell-label">Bid Validity Period (in Days)</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.bidValidityInDays}}</span>
                      </td>

                      <td>
                        <span class="cell-label"></span>
                      </td>
                      <td>
                        <span class="cell-detail"></span>
                      </td>
                    </tr>

                  </table>
                </div>
              </div>
            </div>
            <!---mobile view start --->
            <div class="card-12 d-block d-lg-none mt-40" id="ImportantDates_sectionMobile" #ImportantDatesMobile>
              <div class="card-header">
                Important Dates
              </div>
              <div class="card-body" [appRestrictByFeature]="'pdpTenderOverview'" [appRestrictByStateSlug]="stateSlug">
                <ul>
                  <li>
                    <span class="heading">ePublished Date </span>
                    <span class="content"> {{tender?.publishDate}} </span>
                  </li>
                  <li>
                    <span class="heading ">Bid Opening Date</span>
                    <span class="content">{{tender?.bidOpeningDate}}</span>
                  </li>
                  <li>
                    <span class="heading w-100">Document Download Start Date</span>
                    <span class="content w-100">{{tender?.docDownloadStartDate}}</span>
                  </li>
                  <li>
                    <span class="heading w-100">Document Download End Date</span>
                    <span class="content w-100">{{tender?.docDownloadEndDate}}</span>
                  </li>
                  <li>
                    <span class="heading">Clarification End Date</span>
                    <span class="content">{{tender?.clarificationStartDate}}</span>

                  </li>
                  <li>
                    <span class="heading">Clarification End Date</span>
                    <span class="content">{{tender?.clarificationEndDate}}</span>
                  </li>

                  <li>
                    <span class="heading w-100">Bid Submission Start Date</span>
                    <span class="content w-100">{{tender?.bidSubmissionStartDate}}</span>
                  </li>
                  <li>
                    <span class="heading w-100">Bid Validity Period (in Days)</span>
                    <span class="content w-100">{{tender?.bidValidityInDays}}</span>
                  </li>
                </ul>
              </div>

            </div>
            <!---mobile view end--->
            <!--Important Dates End From Here-->

            <!--Cost Specification Start From Here-->
            <div class="card card-4 border-0 desription-card mt-40" id="CostSpecification_section" #CostSpecification>
              <div class="card-header border-bottom-0 mb-0">
                <h3 class="mb-0">Cost Specification</h3>
              </div>
              <div class="card-body p-0" [appRestrictByFeature]="'pdpTenderOverview'"
                [appRestrictByStateSlug]="stateSlug">
                <div class="table-responsive">
                  <table class="tender-info-table">
                    <tr>
                      <td class="w-p300">
                        <span class="cell-label"> Tender Fee </span>
                      </td>
                      <td>
                        <span class="cell-detail">
                          <ng-container *ngIf="tender?.tenderFee; else referDocument">
                            ₹ {{ tender.tenderFee }}
                          </ng-container>
                          <!-- Fallback text -->
                          <ng-template #referDocument>
                            Refer document
                          </ng-template>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="cell-label">
                          EMD (Earnest Money Deposit)
                        </span>
                      </td>
                      <td>
                        <span class="cell-detail">
                          <!-- Check if emdValue exists -->
                          <ng-container *ngIf="tender?.emdValue; else referDocument">
                            ₹ {{ tender.emdValue.toLocaleString('en-IN') }}
                          </ng-container>
                          <!-- Fallback text -->
                          <ng-template #referDocument>
                            Refer document
                          </ng-template>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="cell-label"> EMD Fee Type </span></td>
                      <td>
                        <span class="cell-detail"> {{tender?.emdFeeType}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="cell-label"> Payment Instruments/Mode </span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.paymentMode}} </span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!--Cost Specification End From Here-->

            <!-- Tender Descriptions Start From Here-->
            <div class="card card-4 border-0 desription-card mt-40 mb-0" id="TenderDescriptions_section"
              #TenderDescriptions>
              <div class="card-header border-bottom-0 mb-0">
                <h3 class="mb-0">Tender Description</h3>
              </div>
              <div class="card-body" [appRestrictByFeature]="'pdpTenderOverview'" [appRestrictByStateSlug]="stateSlug">
                <p><b>Work Description</b> - {{tender?.workDescription}}</p>
                <p>{{tender?.summary}}</p>
              </div>
            </div>
            <!-- Tender Descriptions End From Here-->

            <div class="mt-40">
              <app-credlix-ads-listing-page></app-credlix-ads-listing-page>
            </div>

            <!--Tender Contact Details Start From Here-->
            <div class="card card-4 border-0 desription-card mt-40" id="TenderContactDetails_section"
              #TenderContactDetails>
              <div class="card-header border-bottom-0 mb-0">
                <h3 class="mb-0">Tender Contact Details</h3>
              </div>
              <div class="card-body p-0" [appRestrictByFeature]="'pdpTenderOverview'"
                [appRestrictByStateSlug]="stateSlug">
                <div class="table-responsive">
                  <table class="tender-info-table">
                    <tr>
                      <td class="w-p300">
                        <span class="cell-label"> Office Inviting Bids </span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderInvitingAuthorityName}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="cell-label">Address</span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderInvitingAuthorityAddress}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="cell-label"> Contact Details </span></td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderInvitingAuthorityContact}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="cell-label"> Email </span>
                      </td>
                      <td>
                        <span class="cell-detail">{{tender?.tenderInvitingAuthorityEmail}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="cell-label"> Website </span></td>
                      <td>

                        <span class="cell-detail">
                          <a *ngIf="tender?.website !== 'NA'; else noLink" class="link-2" [href]="tender?.website"
                            target="_blank">{{ tender?.website }}</a>
                          <ng-template #noLink>{{ tender?.website }}</ng-template>
                        </span>

                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!--Tender Contact Details End From Here-->

            <!--Tender Documents Start From Here-->
            <div class="card card-4 border-0 documents-card mt-40" id="document_section" #document>
              <ng-container>
                <div class="card-header border-bottom-0 mb-0">
                  <h3 class="mb-0">Documents</h3>
                </div>
                <div class="card-body py-0" [appRestrictByFeature]="'pdpTenderOverview'"
                  [appRestrictByStateSlug]="stateSlug">

                  <ul class="documents-list ps-0">
                    <ng-container *ngFor="let doc of tender?.documents">
                      <li class="d-flex justify-content-between align-items-center"
                        (click)="isLoggedIn ? downloadDoc(doc) : openModalWithComponent()" style="cursor: pointer;">

                        <div class="d-flex align-items-center">
                          <i class="sprite-img-list attachment-icon mr-20"></i>
                          <div>
                            <h5>Document</h5>
                            <span class="link">{{ doc?.name }}</span>
                          </div>
                        </div>

                        <!-- You can keep the visual download button if needed for larger screens -->
                        <div class="d-none d-lg-flex">
                          <a class="download-btn"
                            (click)="$event.stopPropagation(); isLoggedIn ? downloadDoc(doc) : openModalWithComponent()">
                            <i class="download-icon sprite-img-list "></i>
                            Download
                          </a>
                        </div>

                        <!-- Small screen icon only -->
                        <div class="d-flex d-lg-none">
                          <a class="download-btn"
                            (click)="$event.stopPropagation(); isLoggedIn ? downloadDoc(doc) : openModalWithComponent()">
                            <i class="download-icon sprite-img-list "></i>
                          </a>
                        </div>
                      </li>
                    </ng-container>
                  </ul>

                  <ul class="documents-list ps-0" *ngIf="(!tender?.documents || tender?.documents?.length === 0)">
                    <li *ngIf="tender?.publishDate < tender?.docDownloadStartDate">Tender document will be available to
                      download after
                      <b>{{tender?.docDownloadStartDate}}</b>. Please check authority website for further updates.
                    </li>
                    <li *ngIf="tender?.publishDate >= tender?.docDownloadStartDate">Document Not Available</li>
                  </ul>
                </div>
              </ng-container>
            </div>
            <!--Tender Documents End Here-->

            <div class="adv-4 mt-40">
              <div class="row">
                <div class="col-sm-8">

                  <h3>Secure Your Projects with Tender Material & Financing</h3>
                  <ul>
                    <li>Secure competitive project proposals.</li>
                    <li>Strategic funding solutions to drive your projects to success.</li>
                  </ul>
                </div>
                <div class="col-sm-4 d-flex align-items-center justify-content-end">
                  <a class="know-more-btn" href="https://www.credlix.com/" target="_blank">
                    <span> Yes I Am Interested </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="tender?.similarTenders?.length > 0">
            <app-similar-tender class="d-block mt-40 p-0" [similarTenderData]="tender?.similarTenders"
              [pageType]="'detail'"></app-similar-tender>
          </div>

          <div *ngIf="!isMobileCheck" class="mt-40">
            <app-supplier-central-ads-listing-page></app-supplier-central-ads-listing-page>
          </div>
        </div>

        <div class="col-sm-2 ads-section">
          <app-common-side-card [TenderByKeywords]="TenderByKeywords"
            [TenderByCities]="TenderByCities"></app-common-side-card>
        </div>
      </div>
    </div>
  </section>
  <app-keywords-section></app-keywords-section>
</ng-container>

<app-thankyou-modal *ngIf="isBrowser"></app-thankyou-modal>

<div *ngIf="isModalvis && isBrowser">
  <app-signin-with-otp [tenderdetails]="tenderdetails"></app-signin-with-otp>
</div>

<ng-container *ngIf="isBrowser">
  <app-notification-banner></app-notification-banner>
</ng-container>